export interface AppMessage {
    source: 'ubiko-admin' | 'ubiko-tech',
    type: string;
    data: {
        token?: string;  
        id_team?: string;
        id_squad?: string;
        locale?: string;
    };   
    errors?: string[];
}

export const MESSAGE_TYPE_CHANGE_TEAM = 'changes-team';
export const MESSAGE_TYPE_CHANGE_LOCALE = 'changes-locale';
export const MESSAGE_TYPE_CUSTOM_TOKEN = 'custom-token';
export const MESSAGE_TYPE_LOGOUT = 'logout';
export const MESSAGE_TYPE_CUSTOM_TOKEN_ACK = 'custom-token-response';